var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.626,
    height: 40,
    viewBox: "0 0 30.626 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(-745 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(745 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "test-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M85.5,31.669l.029-.038.007-.01a.33.33,0,0,0,.025-.043v-.008c.008-.016.016-.032.023-.048h0c.007-.017.014-.035.019-.053v-.007a.338.338,0,0,1,.014-.054c0-.018,0-.01,0-.016a.138.138,0,0,1,.007-.047.635.635,0,0,0,0-.064V.639A.638.638,0,0,0,85,0H55.638A.638.638,0,0,0,55,.639V39.361a.638.638,0,0,0,.639.639h21.34l.047-.007h.015l.054-.014H77.1l.051-.018h.007l.047-.022h.009l.041-.024.013-.008.037-.026.014-.01a.322.322,0,0,0,.041-.038h0l8.084-8.084h0c.014-.014.026-.027.039-.042ZM56.277,1.277H84.361V30.638a108.225,108.225,0,0,0-8.084,8.084h-20Zm27.18,30.638L77.55,37.821Z",
    transform: "translate(-55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M196.855,81.277h12.237a.639.639,0,0,0,0-1.277H196.855a.639.639,0,1,0,0,1.277Z",
    transform: "translate(-184.198 -73.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M121.466,64.5a.639.639,0,0,0,.9,0l3.4-3.4a.639.639,0,1,0-.9-.9l-2.953,2.953-.825-.825a.639.639,0,1,0-.9.9Z",
    transform: "translate(-114.471 -54.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M185,150.639a.638.638,0,0,0,.639.639h13.189a.639.639,0,0,0,0-1.277H185.639a.638.638,0,0,0-.639.638Z",
    transform: "translate(-173.936 -137.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M119.042,130h-3.4a.638.638,0,0,0-.639.639v3.4a.638.638,0,0,0,.639.639h3.4a.638.638,0,0,0,.639-.639v-3.4a.638.638,0,0,0-.639-.639Zm-.639,3.4h-2.128v-2.128H118.4Z",
    transform: "translate(-109.894 -118.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M198.825,220H185.635a.639.639,0,0,0,0,1.277h13.189a.639.639,0,1,0,0-1.277Z",
    transform: "translate(-173.933 -201.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M119.042,200h-3.4a.638.638,0,0,0-.639.639v3.4a.638.638,0,0,0,.639.639h3.4a.638.638,0,0,0,.639-.639v-3.4a.638.638,0,0,0-.639-.639Zm-.639,3.4h-2.128v-2.128H118.4Z",
    transform: "translate(-109.894 -182.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M198.825,290H185.635a.639.639,0,0,0,0,1.277h13.189a.639.639,0,0,0,0-1.277Z",
    transform: "translate(-173.933 -265.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M119.042,270h-3.4a.638.638,0,0,0-.639.639v3.4a.638.638,0,0,0,.639.639h3.4a.638.638,0,0,0,.639-.639v-3.4a.638.638,0,0,0-.639-.639Zm-.639,3.4h-2.128v-2.128H118.4Z",
    transform: "translate(-109.894 -247.022)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(759.857 412.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-svgrepo-com_2_",
    "data-name": "add-svgrepo-com (2)",
    transform: "translate(2.143 2.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M6,12h4.045",
    transform: "translate(-6 -9.977)",
    fill: "none",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M12,10.045V6",
    transform: "translate(-9.977 -6)",
    fill: "none",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M4,8A4,4,0,1,1,8,4,4,4,0,0,1,4,8ZM4,.667A3.333,3.333,0,1,0,7.333,4,3.337,3.337,0,0,0,4,.667Z",
    transform: "translate(0.143 0.429)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTest);
export default __webpack_public_path__ + "static/media/create-test.d56e5363358df794a596f1dc593c8f0d.svg";
export { ForwardRef as ReactComponent };